export default __webpack_public_path__ + "static/media/dozule10.ae9441d1.jpg";